import Phaser from 'phaser'

export default class Chest extends Phaser.Physics.Arcade.Sprite
{
	private coins : number
	private bubble : Phaser.GameObjects.Image
	private text: Phaser.GameObjects.Text

	constructor(scene: Phaser.Scene, x: number, y: number, texture: string, frame?: string | number)
	{
		super(scene, x, y, texture, frame)

		this.play('chest-closed')
		this.coins = 0;
		this.bubble = scene.add.image(this.x, this.y - 24, 'bubble')
		this.bubble.visible = false
		this.bubble.z = 10001
		this.text = this.scene.add.text(this.bubble.x, this.bubble.y - 9, '--', { fontFamily: '"Monospace"', fontSize: '8', color: '#000'})
		this.text.visible = false
	}

	open()
	{
		if (this.anims.currentAnim.key == 'chest-closed')
		{
			this.play('chest-open')
		}
	}

	close()
	{
		if (this.anims.currentAnim.key == 'chest-open')
		{
			this.play('chest-closed')
		}

	}

	add() {
		this.close()
		this.coins++
		this.text.setText('' + this.coins)
		if (this.coins > 0) {
			// this.bubble.visible = true
			// this.bubble.z = 1000
			// this.text.visible = true;
		}
	}

	remove(qty : number) {
		this.coins -= qty;
		this.close()
		if (this.coins <= 0) {
			this.bubble.visible = false
			this.text.visible = false
		}
		else
			this.text.setText('' + this.coins)
	}

	public getCoins() {
		return this.coins
	}

}
